export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/word.0b909d0.svg";